import { FormGroupState } from "ngrx-forms";

export interface IMobileVerificationState {
    form: FormGroupState<MobileVerificationModel>;
    message: string;
    dataSaved: boolean;
}

export class MobileVerificationModel {
    mobile: string = '';
    mobileCode: string = '';
    isMobileVerified: boolean = false;
}